<script>
import Layout from "@/Layouts/PublicLayout.vue";

export default {
    layout: Layout,
};
</script>
<script setup>
import { Head, Link } from "@inertiajs/vue3";
import VDevider from "@/Shared/VDevider.vue";
import { useLangStore } from "../../../Store/language";

const langStore = useLangStore();
langStore.getLang();

const TYPE_SURVEY_DEPARTING = "departing-visitor-survey";
const TYPE_SURVEY_OUTBOUND = "sabah-outbound-survey";

const props = defineProps({
    title: String,
    additional: Object,
});

const { urlCreate, survey } = props.additional;

if (survey.code == TYPE_SURVEY_OUTBOUND) {
    langStore.setLang("en");
}
</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <div class="mb-5">
        <h1 class="text-center">{{ $t("public.page.survey_thanks.title") }}</h1>
        <VDevider />
        <h1 class="text-center">Ponsikou</h1>
    </div>

    <div class="text-center">
        <a class="btn btn-lg btn-primary px-5 rounded-pill" :href="urlCreate">
            <span class="material-icons"> list_alt </span>
            {{ $t("public.page.survey_thanks.btn_create_text") }}
        </a>
    </div>
</template>
